/**
 * *** DO NOT EDIT ***
 */

const COLLAPSED_CLASS = 'collapsed';
const COLLAPSING_CLASS = 'collapsing';
const SHOW_CLASS = 'show';

module.exports = class Accordion {
    constructor({ selector = '', duration = 600, openOnInit = [] }) {
        require('./main.css');
        if (selector && document.querySelector(selector)) {
            let accordion = require('accordion-js');
            new accordion(selector, {
                duration: duration,
                showMultiple: false,
                triggerClass: 'accordion-trigger',
                elementClass: 'accordion-item',
                panelClass: 'accordion-body',
                openOnInit: openOnInit,
            });
        }
    }
};
